import styled from "styled-components";
import { theme } from '../../theme'
import { styled as styledMui } from "@material-ui/core/styles"
import { Avatar } from "@material-ui/core"

export const ViewAnnouncementCard = styled.div`
background-color: ${theme.colors.mainWhite};
box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.0293252);
border-radius: 1.1rem;
`

export const ViewAnnouncementCardTop = styled.div`
padding: 1.5rem 3.5rem  1.5rem 0.9rem;
border-bottom: 1px solid #D8D8D8;
display: flex;
align-items: center;

    .avatar-and-name {
        display: flex;
        align-items: center;
    }

    .announcement-name-info {
        margin-left: 0.7rem;

        .announcer-name {
            font-weight: 700;
            font-size: 1.2rem;
            color: #3B3B42;
        }

        .announcement-time {
            font-size: 1rem;
            color: #979797;
        }
    }

    .icon-container {
        margin-left: auto;
        color: ${theme.colors.mainBlue};
        cursor: pointer;

        svg {
            width: 2rem;
            height: 2rem;
        }
        
    }
`

export const ViewAnnouncementCardBody = styled.div`
padding: 2rem 3.5rem  3rem 0.9rem;

    .view-announcement-card-body-top {
        display: flex;
        align-items: center;
        margin-bottom: 2.2rem;

        .icon-container {
            width: 3.5rem;
            height: 3.5rem;
            color: ${theme.colors.mainBlue};
            background: rgba(33, 150, 243, 0.44);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
    
            svg {
                height: 2.4rem;
                width: 2.4rem;
            }
        }

        .announcement-title {
            margin-left: 1.1rem;
        }
    }

    .view-announcement-card-body-main {
        p {
            margin-left: 44px;
            font-size: 1.2rem;
        line-height: 1.4rem;
        color: #979797;
        white-space: pre-line;
        }
        
    }
`

export const CustomAvatar = styledMui(Avatar)(({ theme }) => ({
    width: '3.5rem',
    height: '3.5rem',
}));